<app-organizer-shared-layout-funnel
  [class]="builtLayoutCssClass"
  [hasCloseButton]="false"
>
  <app-organizer-shared-page-container>
    <img alt="" class="information-mobile-picture" [src]="mobileImageSource" />

    <h1 class="information-title title-2">
      {{ titleKey | translate }}
    </h1>

    <p [innerText]="descriptionKey | translate"></p>

    <app-organizer-shared-navigation-buttons
      nextQueryParametersHandling="preserve"
      [nextDisabled]="false"
      [previousQueryParametersHandling]="previousQueryParametersHandling"
    ></app-organizer-shared-navigation-buttons>
  </app-organizer-shared-page-container>

  <app-beveled-picture
    layout-right-content
    class="information-background-picture"
    [src]="imageSource"
  ></app-beveled-picture>
</app-organizer-shared-layout-funnel>
